import { FieldError } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { FormError } from 'coreOld/elements';

import { TextEditorWrapper } from './textEditorStyle';

interface IProps {
  name: string;
  value?: string;
  placeholder?: string;
  onChange?;
  control?;
  getValues?;
  setValue?;
  error?: FieldError | string;
  showFieldError?: boolean;
}

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline'],
    ['link'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean'],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'list',
  'bullet',
  'link',
  'color',
  'background',
  'clean',
];

const TextEditorView = ({
  name,
  value,
  placeholder,
  onChange,
  control,
  getValues,
  setValue,
  error,
  showFieldError,
}: IProps) => {
  const inputValue = control ? getValues(name) : value;

  return (
    <TextEditorWrapper>
      <ReactQuill
        {...{
          id: name,
          name,
          theme: 'snow',
          value: inputValue,
          placeholder,
          onChange: (value) => {
            if (setValue) {
              setValue(name, value);
            }

            if (onChange) {
              onChange(value);
            }
          },
          modules,
          formats,
          error,
        }}
      />

      {showFieldError && error && <FormError error={error} />}
    </TextEditorWrapper>
  );
};

export default TextEditorView;
